export type Colors = typeof colors;
export const colors = {
  black: '#000000',
  neutral35: '#6E6E6E',
  neutral40: '#666666',
  neutral75: '#BBBBBB',
  neutral80: '#CCCCCC',
  neutral85: '#D6D6D6',
  neutral90: '#E6E6E6',
  neutral91: '#E8E8E8',
  neutral94: '#F3F3F3',
  neutral95: '#F4F4F4',
  neutral99: '#FCFCFC',
  white: '#FFFFFF',
  error35: '#EE0000',
  fullscreenBackgroundColor: 'rgba(24, 27, 27, 0.8)',
  green: '#008A27',
  superlightOrange: '#FFF9F0',
  darkOrange: '#EE9100',
  overlayBackgroundColor: 'rgba(0, 0, 0, 0.2)',
  darkGrey: '#767676',
  grey: '#999999',
  superlightGrey: '#F7F7F7',
} as const;
